import { setContext } from '@apollo/client/link/context';
import { getAuthToken } from '../app/actions/app-general-actions';

export const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});
